const map = {
	"./avatar-1.jpg": 1162,
	"./avatar-2.jpg": 6885,
	"./avatar-3.jpg": 2568,
	"./avatar-4.jpg": 9307,
	"./avatar-5.jpg": 1262,
	"./back-login@3x.png": 5281,
	"./background-chat.png": 3372,
	"./caremePrivacy.svg": 4914,
	"./doc.png": 8681,
	"./epico-blanco.png": 4969,
	"./epico.png": 8369,
	"./favicon.ico": 804,
	"./hospital.jpg": 8953,
	"./ico-chat.svg": 9569,
	"./jpg.png": 7686,
	"./logo-menu-colapsado.svg": 3783,
	"./logoCaremeLogin.svg": 746,
	"./memphis-colorful.png": 7025,
	"./pdf.png": 1577,
	"./png.png": 1086,
	"./ruber.jpg": 5909
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;